export default function Spinner() {
	return (
		<div className="loader">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="104"
				height="105"
				viewBox="-8 -8 120 120"
				fill="none"
				style={{ overflow: "visible" }}
			>
				<g class="spin">
					<path
						d="M103.3 88.6L101 90.9C93.3003 98.6 80.7003 98.6 72.9003 90.9L34.3003 52.3L52.1003 34.5L103.4 85.8C104.2 86.6 104.2 87.8 103.4 88.6H103.3Z"
						fill="#00C34B"
					/>
					<path
						d="M52.0001 34.6006L69.8002 52.4006L18.5001 103.701C17.7001 104.501 16.5001 104.501 15.7001 103.701L13.3001 101.301C5.60015 93.6006 5.60015 81.0006 13.3001 73.3006L52.0001 34.6006Z"
						fill="#FFC300"
					/>
					<path
						d="M88.3002 1.10039L90.6002 3.40039C98.4002 11.2004 98.4002 23.8004 90.6002 31.5004L52.0002 70.1004L34.2002 52.3004L85.5002 1.00039C86.3002 0.200391 87.5002 0.200391 88.3002 1.00039V1.10039Z"
						fill="#289BFF"
					/>
					<path
						d="M69.8001 52.3006L52.0001 70.1006L0.700098 18.8006C-0.0999024 18.0006 -0.0999024 16.8006 0.700098 16.0006L3.0001 13.7006C10.8001 5.90059 23.4001 5.90059 31.1001 13.7006L69.7001 52.3006H69.8001Z"
						fill="#289BFF"
					/>
				</g>

				<g class="pulse">
					<path
						d="M33.8002 34.4L34.1002 34.1C38.9002 29.3 46.7002 29.3 51.6002 34.1L69.9002 52.4L52.1002 70.2L33.8002 51.9C29.0002 47.1 29.0002 39.3 33.8002 34.4Z"
						fill="#00288C"
					/>
					<path
						d="M70.0002 34.1L70.3002 34.4C75.1002 39.2 75.1002 47 70.3002 51.9L52.0002 70.2L34.2002 52.4L52.5002 34.1C57.3002 29.3 65.1002 29.3 70.0002 34.1Z"
						fill="#00288C"
					/>
				</g>
			</svg>
		</div>
	);
}

// <style>
//     .spin {
//       animation: spin 6s linear infinite;
//       transform-origin: 52px 52.5px;
//     }
//     .pulse {
//       animation: pulse 1.5s ease-in-out infinite;
//       transform-origin: 52px 52.5px;
//     }

//     @keyframes spin {
//       0% { transform: rotate(0deg); }
//       100% { transform: rotate(360deg); }
//     }

//     @keyframes pulse {
//       0%, 100% { transform: scale(1); }
//       50% { transform: scale(1.1); }
//     }
//   </style>
